/**
 * Outcome of looking up which QBO invoice (if any) an order's estimate became
 * (API: QuickbooksOnlineService.findInvoicesForOrderEstimate). The API reports the first that applies.
 *
 * - NO_ESTIMATE: the order has no qbo_EstimateId.
 * - ESTIMATE_NOT_FOUND: QBO has no estimate with that id (deleted in QBO).
 * - ORDER_LINKED: the order already has its invoice (qbo_EntityId).
 * - INVOICE_LINKS_ESTIMATE: an invoice names the estimate in its own LinkedTxn, which the Invoice Create webhook reads.
 * - LINK_NOT_ON_INVOICE: QBO records the link only on the estimate or the invoice lines, which the webhook does not read.
 * - UNLINKED_MATCH: no QBO link, but an invoice has the same lines or total (likely copied rather than converted).
 * - NO_MATCH: nothing linked or matching.
 */
enum QBOEstimateInvoiceDiagnosisEnum {
    NO_ESTIMATE = "NO_ESTIMATE",
    ESTIMATE_NOT_FOUND = "ESTIMATE_NOT_FOUND",
    ORDER_LINKED = "ORDER_LINKED",
    INVOICE_LINKS_ESTIMATE = "INVOICE_LINKS_ESTIMATE",
    LINK_NOT_ON_INVOICE = "LINK_NOT_ON_INVOICE",
    UNLINKED_MATCH = "UNLINKED_MATCH",
    NO_MATCH = "NO_MATCH",
}

export default QBOEstimateInvoiceDiagnosisEnum;
